// extracted by mini-css-extract-plugin
export default {"overlay":"EOC1MJd3fs5qsrMZsZJ4"};